// shop-frontend/src/pages/ShopLowStock.jsx
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import LowStockAlerts from "../components/LowStockAlerts";

export default function ShopLowStock() {
  return (
    <div className="min-h-screen bg-zinc-950 page-responsive">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-4 mb-6">
          <Link
            to="/shop/dashboard"
            className="p-2 text-zinc-400 hover:text-white hover:bg-zinc-800 rounded-lg transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
          </Link>
          <div>
            <h1 className="text-2xl font-bold text-white">Low Stock Management</h1>
            <p className="text-zinc-400 text-sm">
              Track and restock products running low on inventory
            </p>
          </div>
        </div>

        {/* Full Low Stock Component */}
        <LowStockAlerts compact={false} />
      </div>
    </div>
  );
}
